var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-snackbar",class:{
      'default-snackbar--success': _vm.type === 'success',
      'default-snackbar--error': _vm.type === 'error'
    }},[_c('div',{staticClass:"default-snackbar__message"},[_vm._v(_vm._s(_vm.message))]),_c('img',{staticClass:"default-snackbar__close",attrs:{"src":require("@/assets/images/svg/close-white.svg"),"alt":"exchange icon"},on:{"click":_vm.hideSnackbar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }